import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as UserDataConfig from '../../config/user-data.config';
import { AnalyticsService, FormValidationsService, AnnuitantDetailService, SERVICE_END_POINT, AuthService } from '../../../../shared';
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { UtilService } from '../../../../shared';
import { PaymentDetails } from 'src/app/model/ngrx/payment-details.model';
import * as paymentDetailsActions from '../../../../store/actions/payment-details.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit, OnDestroy {
  paymentDetailForm: UntypedFormGroup;
  registrationConfiguration: object;
  public afterApplyDetail = UserDataConfig.ElementsConfig;
  protected registerButtonConfig = this.afterApplyDetail.regsiterbuttonConfig;
  public sortCodeconfig = this.afterApplyDetail.sortCodeConfigVal;
  public accountNumberCodeConfig = this.afterApplyDetail.accountNumberConfigVal;
  public bankNameCodeConfig = this.afterApplyDetail.bankNameConfigVal;
  public rollNumberCodeConfig = this.afterApplyDetail.rollNumberConfigVal;
  public accountHolderCodeConfig = this.afterApplyDetail.accountHolderConfigVal;
  public accountNumberTooltipConfig = this.afterApplyDetail.accountNumberToolTipInfoConfig;
  public rollNumberTooltipConfig = this.afterApplyDetail.rollNumberToolTipInfoConfig;
  bankdetailsStore: Observable<PaymentDetails[]>;
  bankdetails: PaymentDetails;
  public responseApplicationData: any[];
  private responseApplicationDataStore: Observable<any[]>;
  private applicationDataResponsesubs: Subscription;
  bankName: string;
  rollNo;
  showRollNo: boolean = false;
  contentData;
  dontShowPaymentForm: boolean = false;
  CMSData;
  tooltipModal;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private subscriptn: Subscription;
  displayTooltipAlert = false;
  public tooltipModalConfig: AlertModal;
  //disableTextbox:boolean = false ;
  
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private _location: Location,
    private activatedRoute: ActivatedRoute,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    // tslint:disable-next-line:variable-name
    public el: ElementRef,
    private store: Store<AppState>,
    private utilService: UtilService) {
    this.applicationDataResponsesubs = this.store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
      }
    });
    this.contentData = this.route.snapshot.data.contentData.paymentDetails;
    this.bankdetailsStore = store.select(STORE_VAL.bank_details);
    /*     susbscribing to bank detail store*/
    this.bankdetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.bankdetails = val[0];
      }
    });
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }
  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.GetCMSDataServiceMapper();
    // set button label
    this.afterApplyDetail.buttonConfig.label = 'Next';
    this.dontShowPaymentForm = false;
    this.userFormData();
    this.rollNo = this.paymentDetailForm.get('rollNumber');
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress  = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.paymentDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }
  backtoPrevious() {
    this.saveFormValues();
    this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
    this.store.dispatch(new paymentDetailsActions.AddPaymentDetails(this.paymentDetailForm.value));
  }
  ngOnDestroy() {
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.applicationDataResponsesubs){
      this.applicationDataResponsesubs.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveFormValues() {
    this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
    this.store.dispatch(new paymentDetailsActions.AddPaymentDetails(this.paymentDetailForm.value));
  }
  userFormData = () => {
    /* to display data from bank detail store when navigating again to this page */
    if (this.bankdetails && !this.checkProperties(this.bankdetails)) {
      this.dontShowPaymentForm = this.bankdetails && this.bankdetails.accountType ? true : false;
      this.bankdetails = {...this.bankdetails , bankName: this.bankdetails && this.bankdetails.accountType ? null : this.bankdetails.bankName};
      this.paymentDetailForm = this.fb.group({
        sortcode: [this.bankdetails && this.bankdetails.sortcode ? (this.bankdetails.sortcode.match(/[^-]{2,2}/g)|| []).join('-') : null, [Validators.required, Validators.pattern('^[0-9]{2}[-][0-9]{2}[-][0-9]{2}$')]],
        accountNumber: [this.bankdetails && this.bankdetails.accountNumber ? this.bankdetails.accountNumber : null, [Validators.required, Validators.pattern('^[0-9]{7,8}$')]],
        bankName: [this.bankdetails && this.bankdetails.bankName ? this.bankdetails.bankName : null, [Validators.required]],
        rollNumber: [this.bankdetails && this.bankdetails.rollNumber ? this.bankdetails.rollNumber : null, Validators.pattern('^[a-zA-Z0-9]{1,35}')],
        accountHolder: [this.bankdetails && this.bankdetails.accountHolder ? this.bankdetails.accountHolder : null, [Validators.required]],
        accountType: [this.bankdetails && this.bankdetails.accountType ? this.bankdetails.accountType : null]
      });

    } else {
    this.paymentDetailForm = this.fb.group({
      sortcode: ['', [Validators.required, Validators.pattern('^[0-9]{2}[-][0-9]{2}[-][0-9]{2}$')]],
      accountNumber: ['', [Validators.required, Validators.pattern('^[0-9]{7,8}$')]],
      bankName: [{ value: '', disabled: true }, [Validators.required]], //changed as part of the story RA-3961- Add input validation on bank account page Account Holder(s) field
      rollNumber: ['', Validators.pattern('^[a-zA-Z0-9]{1,35}')],
      accountHolder: ['', [Validators.required]],
      accountType: [null]
    });
  } 
  }
  /* getting bank name from auddis service on blur of account number field */
  getbankName(data, controlName) {

    if (this.paymentDetailForm.get('sortcode').valid && this.paymentDetailForm.get('accountNumber').valid
      && this.dontShowPaymentForm === false) {
      if (this.paymentDetailForm.value.sortCode !== '' && this.paymentDetailForm.value.accountNumber !== '') {
        this.saveFormValues();
        this.applicationDatacaptureService.getBankName(true).subscribe(res => {
       
         // if sort code and account number match
        if(res['validBankdetails'] === true){
          this.bankName = res['bankName'];
          this.paymentDetailForm.get('bankName').setValue(this.bankName);
          this.bankNameCodeConfig.readonly = true;
          this.paymentDetailForm.get('bankName')?.enable();
          
        }
        else{
          this.paymentDetailForm.get('accountNumber').setErrors({'matchInvalid':true});
          }
        });

      } else { 
        //console.log("sortcode and account number is null");
        // changed as part of the story RA-3961- Add input validation on bank account page Account Holder(s) field
        this.paymentDetailForm.get('bankName').setValue('');
        this.paymentDetailForm.get('bankName')?.disable();
      }
    } else {
      //console.log("not valid controls");
      //changed as part of the story RA-3961- Add input validation on bank account page Account Holder(s) field
      this.paymentDetailForm.get('bankName').setValue('');
      this.paymentDetailForm.get('bankName')?.disable();
    }
  }
  /* save data to db on click of next */
  gotoNext() {
    if (this.paymentDetailForm.valid && this.dontShowPaymentForm === false) {
      this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
      this.store.dispatch(new paymentDetailsActions.AddPaymentDetails(this.paymentDetailForm.value));
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        this.showRollNo = false;
        this.router.navigate(['apply/your-product-application']);
      });
     
        }
    if (this.dontShowPaymentForm === true) {
      //console.log(this.bankdetails);
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        this.showRollNo = false;
        this.router.navigate(['apply/your-product-application']);
      });
    } else {
      FormValidationsService.validateAllFormFields(this.paymentDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  /*   method for checkbox to hide payment form for non uk bank customer*/
  toggleVisibility(event) {
    if (event.target.checked) {
      this.dontShowPaymentForm = true;
      // this.paymentDetailForm.reset();
      this.setNullValues();
      this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
      this.store.dispatch(new paymentDetailsActions.AddPaymentDetails(this.paymentDetailForm.value));
    } else {
      this.dontShowPaymentForm = false;
    }
  }
/* method to keep check on null values */
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  /* method to clear off data when the accountType is Overseas bank account*/
  setNullValues() {
    this.paymentDetailForm.get('sortcode').setValue(null);
    this.paymentDetailForm.get('accountNumber').setValue(null);
    this.paymentDetailForm.get('bankName').setValue(null);
    this.paymentDetailForm.get('rollNumber').setValue(null);
    this.paymentDetailForm.get('accountHolder').setValue(null);
  }

    /** Code block for CMS */
    GetCMSDataServiceMapper() {

      const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPaymentDetails;
      this.utilService.getCMSData(URL).subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.introduction = this.CMSData.string_ApplyYourPaymentDetailsSubTitle1;
          this.contentData.header = this.CMSData.string_ApplyYourPaymentDetailsTitle;
          this.contentData.nonUkBank = this.CMSData.string_ApplyYourPaymentDetailsSubTitle2;
          this.accountNumberTooltipConfig.content = this.CMSData.string_AccountNumberInfoWording;
          this.accountNumberCodeConfig.errorMessageInvalid = this.CMSData.string_AccountNoErrorMessage;
          this.rollNumberTooltipConfig.content = this.CMSData.string_RollNoInfoWording;
        }
      });
  
    }

    closeTooltipModal() {
      this.displayTooltipAlert = false;
    }

    alertTooltipPrimaryBtnClick() {
      this.displayTooltipAlert = false;
    }

    displayTooltipMessage(el: String) {
      let config;

      switch(el) {
        case "accountNumber":
          config = this.accountNumberTooltipConfig;
          break;
        case "rollNumber":
          config = this.rollNumberTooltipConfig;
          break;          
      }
      this.tooltipModal.content = config.content;
      this.displayTooltipAlert = true;
    }
}


